/* eslint-disable */
// /src/services/franchiseStorePublicService.js
// 가맹점 스토어 공개 조회용 서비스 (프론트 앱에서 사용)
// - 컬렉션: franchise_products
//   - 관리자 페이지에서 사용하는 컬렉션과 동일
//   - 여기서는 status === "active" 만 노출

import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    where,
    orderBy,
} from "firebase/firestore";
import { db } from "./firebase";

const COL = "franchise_products";

// 활성 상품 목록 조회
export async function fetchActiveFranchiseProducts(limitCount = 200) {
    const q = query(
        collection(db, COL),
        where("status", "==", "active"),
        orderBy("displayOrder", "asc")
    );

    const snaps = await getDocs(q);
    const rows = snaps.docs.map((d) => ({ id: d.id, ...d.data() }));

    // 필요하면 상한 자르기
    return rows.slice(0, limitCount);
}

// 단일 상품 조회
export async function fetchFranchiseProductById(pid) {
    if (!pid) return null;
    const ref = doc(db, COL, pid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data() || {};
    return { id: snap.id, ...data };
}
